import React from 'react'
import { Card, Col, Divider, Row, Typography, Table } from "antd";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";

const { Text } = Typography;


const Preview = (props) => {
  const { formData, loanAccountDetails, customerInfo, productTemplate } = props;

  const productObj =
    loanAccountDetails.productOptions?.find(
      (item) => item.id === formData.details.productId
    );

    const loanOfficerObj =
    productTemplate.loanOfficerOptions?.find(
      (item) => item.id === formData.details.loanOfficerId
    );

    const fundObj =
    loanAccountDetails.fundOptions?.find(
      (item) => item.id === formData.details.fundId
    );

    const repaymentEveryObj =
    loanAccountDetails.repaymentFrequencyTypeOptions?.find(
      (item) => item.id === formData?.terms?.repaymentFrequencyType
    );

    const transactionProcessingStrategyObj =
    loanAccountDetails.transactionProcessingStrategyOptions?.find(
      (item) => item.id === formData.terms.transactionProcessingStrategyId
    );

  const data = {
    details: [
      {
        name: "Customer",
        value: customerInfo?.label ? customerInfo?.label : "-",
      },
      {
        name: "Product",
        value: formData?.details?.productId ? productObj?.name : "-",
      },
      {
        name: "Loan Officer",
        value: formData?.details?.loanOfficerId
          ? loanOfficerObj?.displayName
          : "-",
      },
      {
        name: "Loan Purpose",
        value: formData?.details?.loanPurposeId
          ? formData.details.loanPurposeId
          : "-",
      },
      {
        name: "Fund",
        value: formData?.details?.fundId
          ? fundObj.name
          : "-",
      },
      {
        name: "Submitted On",
        value: formData?.details?.submittedOnDate
          ? formData.details.submittedOnDate
          : "-",
      },
      {
        name: "Disbursement On",
        value: formData?.details?.expectedDisbursementDate
          ? formData.details.expectedDisbursementDate
          : "-",
      }
    ],

    terms: [
      {
        name: labelConfig.principal,
        value: formData?.terms?.principal
          ? formData.terms.principal
          : "-",
      },
      {
        name: labelConfig.loanTerm,
        value: formData?.terms?.loanTermFrequency
          ? formData?.terms?.loanTermFrequency
          : "-",
      },
      {
        name: labelConfig.numberOfRepayments,
        value: formData?.terms?.numberOfRepayments
          ? formData.terms.numberOfRepayments
          : "-",
      },
      {
        name: labelConfig.repaidEvery,
        value: formData?.terms?.repaymentEvery
          ? repaymentEveryObj?.value
          : "-",
      },
      {
        name: labelConfig.firstRepaymentOn,
        value: formData?.terms?.repaymentsStartingFromDate
          ? formData?.terms?.repaymentsStartingFromDate
          : "-",
      },
      {
        name: labelConfig.interestChargedFrom,
        value: formData?.terms?.interestChargedFromDate
          ? formData?.terms?.interestChargedFromDate
          : "-",
      },
      {
        name: labelConfig.nominalInterestRate,
        value: formData?.terms?.interestRatePerPeriod
          ? formData?.terms?.interestRatePerPeriod
          : "-",
      },
      {
        name: labelConfig.interestMethod,
        value: formData?.terms?.interestType
          ? loanAccountDetails?.interestType.value
          : "-",
      },
      {
        name: labelConfig.amortization,
        value: formData?.terms?.amortizationType
          ? loanAccountDetails?.amortizationType.value
          : "-",
      }, 
      {
        name: labelConfig.interestCalculationPeriod,
        value: formData?.terms?.interestCalculationPeriodType
          ? loanAccountDetails?.interestCalculationPeriodType.value
          : "-",
      }, 
      {
        name: labelConfig.calculateInterest,
        value: formData?.terms?.allowPartialPeriodInterestCalcualtion
          ? formData?.terms?.allowPartialPeriodInterestCalcualtion
          : "-",
      },
      {
        name: labelConfig.arrearsTolerance,
        value: formData?.terms?.inArrearsTolerance
          ? formData?.terms?.inArrearsTolerance
          : "-",
      },
      {
        name: labelConfig.interestFreePeriod,
        value: formData?.terms?.graceOnInterestCharged
          ? formData?.terms?.graceOnInterestCharged
          : "-",
      },
      {
        name: labelConfig.repaymentStrategy,
        value: formData?.terms?.transactionProcessingStrategyId
          ? transactionProcessingStrategyObj.name
          : "-",
      }
    ],
  };

  const columns = [
    [
      {
        key: " 1",
        title: "Name",
        dataIndex: "name",
      },
      {
        key: " 2",
        title: "Type",
        dataIndex: "type",
      },
      {
        key: " 3",
        title: "Amount",
        dataIndex: "amount",
      },
      {
        key: " 4",
        title: "Collected On",
        dataIndex: "collectedOn",
      },
      {
        key: " 5",
        title: "Date",
        dataIndex: "date",
      }
    ],
  ];

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
      }}
    >
      {/* DETAILS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Details"}
        </Divider>
        {data.details.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* TERMS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Terms"}
        </Divider>
        {data.terms.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* CHARGES FORM */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Charges"}
        </Divider>
        <Table
          pagination={false}
          columns={columns[0]}
          dataSource={formData.previewCharge}
        />
      </div>
    </Card>
  );
};

export default Preview